import { FaStar } from "react-icons/fa";
import { Section, SectionTitle, SectionSubtitle, TestimonialsGrid, TestimonialCard, Stars, Avatar, AvatarCircle } from "./style";

const testimonials = [
	{
		name: "Maria Silva",
		role: "Cliente",
		rating: 5,
		text: "Uso o iNove Clube há meses e já economizei muito! Os cupons são incríveis e o programa de fidelidade é um diferencial enorme.",
	},
	{
		name: "João Santos",
		role: "Lojista",
		rating: 5,
		text: "Desde que cadastrei minha loja no iNove, minhas vendas aumentaram significativamente. A plataforma é fácil de usar e o suporte é excelente.",
	},
	{
		name: "Ana Oliveira",
		role: "Cliente",
		rating: 5,
		text: "Adoro poder encontrar todas as lojas da minha região em um só lugar. A entrega é rápida e os preços são imbatíveis!",
	},
];

export function Testimonials() {
	return (
		<Section>
			<div className="container">
				<div className="text-center">
					<SectionTitle>O que dizem sobre nós</SectionTitle>
					<SectionSubtitle>
						Veja o que nossos clientes e parceiros falam sobre o iNove Clube.
					</SectionSubtitle>
				</div>
				<TestimonialsGrid>
					{testimonials.map((testimonial) => (
						<TestimonialCard key={testimonial.name}>
							<Stars>
								{Array.from({ length: testimonial.rating }).map((_, i) => (
									<FaStar key={`star-${testimonial.name}-${i}`} />
								))}
							</Stars>
							<p className="quote">&ldquo;{testimonial.text}&rdquo;</p>
							<Avatar>
								<AvatarCircle>{testimonial.name.charAt(0)}</AvatarCircle>
								<div>
									<p className="name">{testimonial.name}</p>
									<p className="role">{testimonial.role}</p>
								</div>
							</Avatar>
						</TestimonialCard>
					))}
				</TestimonialsGrid>
			</div>
		</Section>
	);
}
